<template>
  <form
    ref="form"
    enctype="multipart/form-data"
    data-url="/evaluator/documentaryEvaluation"
    class="mb-0"
    :class="{ 'loading-opacity': preloader }"
  >
    <legend>
      <p class="text-primary">Documentos anteriores</p>
    </legend>
    <div class="row">
      <div class="col-12">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 25%"
              >
                USUARIO
              </th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE CREACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="accApp && accApp.request_signed">
              <td class="align-middle">Solicitud de Acreditación</td>
              <td class="align-middle text-center">
                {{
                  accApp.request_signed.user
                    ? `${accApp.request_signed.user.first_name} ${accApp.request_signed.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ accApp.request_signed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(accApp, 'request_signed')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="accApp">
              <td class="align-middle">
                Anexos de la Solicitud de Acreditación
              </td>
              <td class="align-middle text-center">
                {{
                  accApp.user
                    ? `${accApp.user.first_name} ${accApp.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ accApp.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <a
                  class="btn btn-success"
                  :href="`/accreditations/applications/${accApp.id}?tab=Anexos`"
                  target="_blank"
                  ><app-icon name="file" /> {{ $t("view") }}</a
                >
              </td>
            </tr>
            <tr v-if="evalTest.file_evaluation">
              <td class="align-middle">Propuesta del Equipo Evaluador</td>
              <td class="align-middle text-center">
                {{
                  evalTest.file_evaluation.user
                    ? `${evalTest.file_evaluation.user.first_name} ${evalTest.file_evaluation.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.file_evaluation.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'file_evaluation')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.sampling_plan_file">
              <td class="align-middle">Plan de Muestreo</td>
              <td class="align-middle text-center">
                {{
                  evalTest.sampling_plan_file.user
                    ? `${evalTest.sampling_plan_file.user.first_name} ${evalTest.sampling_plan_file.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.sampling_plan_file.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'sampling_plan_file')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.risk_matrix">
              <td class="align-middle">Matriz de Riesgo</td>
              <td class="align-middle text-center">
                {{
                  evalTest.risk_matrix.user
                    ? `${evalTest.risk_matrix.user.first_name} ${evalTest.risk_matrix.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.risk_matrix.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'risk_matrix')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <hr />
    <div class="row">
      <div class="col-12" v-if="evalTest.management_system_file && evalTest.management_system_file.length > 0">
        <legend>
          <p class="text-primary">Documentación del OEC previo a la 
            <span class="title-legend" v-if="evalTest.type == 'E'">evaluación</span>
            <span class="title-legend" v-if="evalTest.type == 'T'">testificación</span>
          </p>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 25%"
              >
                USUARIO
              </th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE CREACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, i) in evalTest.management_system_file" :key="i">
              <td class="align-middle">
                {{ v.filename }}
              </td>
              <td class="align-middle text-center">
                <span v-if="v.annexed">
                  {{ v.annexed.user.first_name }}
                  {{ v.annexed.user.last_name }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span>{{ v.created_at | dateFormat }}</span>
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(v, 'annexed')"
                  v-if="v.annexed"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <hr />

    <div class="row">
      <div class="col-sm-12">
        <legend>
          <p class="text-primary">Designaciones Equipo Evaluador</p>
        </legend>
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center" style="width: 20%">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE ACEPTACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, i) in evalTest.evaluation_team" :key="'e' + i">
              <td class="text-center">
                {{ v.evaluator_type.value }}
              </td>
              <td>{{ capitalizeFirstLetters(v.evaluator.first_name) }} {{ capitalizeFirstLetters(v.evaluator.last_name) }}</td>
              <td class="text-center">
                {{ v.updated_at | dateFormat }}
              </td>
              <td class="text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(v, 'evaluation_team_designation')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-12">
        <app-note
          class="mb-primary"
          :show-title="false"
          :notes="['Todos los campos con un (*) son obligatorios.']"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label
            >Informe de evaluación documental<b
              class="text-danger ml-2"
              style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="file"
            v-model="inputs.file"
            id="report_documentary_evaluation"
            :label="inputs.file ? inputs.file.name : $t('upload_your_file')"
            v-if="!inputs.report_documentary_evaluation"
          />
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="
                openTab(evalTest, 'report_documentary_evaluation')
              "
              v-if="inputs.report_documentary_evaluation"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="inputs.report_documentary_evaluation = null"
              v-if="inputs.report_documentary_evaluation"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="showAccInit">
      <div class="col-sm-12">
        <br />
        <div class="float-left mb-3 mb-3">
          <div class="form-group text-left">
            <label
              >¿La organización evaluada está lista para la evaluación in
              situ?</label
            >
            <app-input
              type="radio-buttons"
              v-model="inputs.insitu_401"
              :list="confirm"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="showQuestionNoConf">
      <div class="col-sm-12">
        <br />
        <div class="float-left mb-3 mb-3">
          <div class="form-group text-left">
            <label
              >¿Existen no conformidades?</label
            >
            <app-input
              type="radio-buttons"
              v-model="inputs.nonconformities_401"
              :list="nonconformities_401"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="inputs.insitu_401 == 0">
      <div class="col-sm-12" v-if="showAccInit">
        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-12 mb-0">
            <h5 class="card-title m-0">Observación</h5>
            <br />
          </label>
          <app-input
            id="inputs_observations"
            class="col-sm-12"
            type="textarea"
            v-model="inputs.observations"            
          />
        </div>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label
            >Alcance de accreditación<b
              class="text-danger ml-2"
              style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="file"
            v-model="inputs.file_1"
            id="scope401"
            :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
            required
            v-if="!inputs.scope401"
          />
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(evalTest, 'scope401')"
              v-if="inputs.scope401"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="inputs.scope401 = null"
              v-if="inputs.scope401"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>
    </div> -->

    <div class="mt-5">
      <button
        type="submit"
        class="btn btn-primary mr-2"
        @click.prevent="submit"
      >
        {{ $t("save") }}
      </button>
    </div>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {},
      showQuestionNoConf: false,
      showAccInit: false,
      nonconformities_401:[
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
    };
  },
  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
        : {};
    },
    accApp() {
      return this.evalTest ? this.evalTest.accreditation_applications : {};
    },
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
  },
  created() {
    this.loadForm();
    this.data();
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.save(formData);
    },

    afterSuccess({ data: { data } }) {
      // this.$toastr.s(res.data.message);
      this.$store.state.evaluatorReview.evalTest = data;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {},

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    loadForm() {
      let tmp;
      if (this.$store.state.evaluatorReview.evalTest) {
        //let obsCount = this.$store.state.evaluatorReview.evalTest.observations_evaluation_team.length - 1;
        tmp = {
          id: this.$store.state.evaluatorReview.evalTest.id,
          report_documentary_evaluation:
            this.$store.state.evaluatorReview.evalTest
              .report_documentary_evaluation,
          scope401: this.$store.state.evaluatorReview.evalTest.scope401,
          insitu_401: this.$store.state.evaluatorReview.evalTest.insitu_401,
          nonconformities_401:  this.$store.state.evaluatorReview.evalTest.nonconformities_401,
          observations: this.$store.state.evaluatorReview.evalTest.observations_evaluation_team.observation,
        };
        if (this.inputs.scope401) {
          tmp.is_required = 1;
        }
        if(this.$store.state.evaluatorReview.evalTest.accreditation_applications){
          var accType = this.$store.state.evaluatorReview.evalTest.accreditation_applications.accreditation_type.name;

          if(accType.match(/Acreditación Inicial*/) ){
            this.showAccInit = true;
          }
          if(accType.match(/Ampliación*/)  || accType.match(/Vigilancia*/) ){
              if (this.$store.state.evaluatorReview.evalTest.vigilance_documentary_evaluation && this.$store.state.evaluatorReview.evalTest.situ_checked) {
                this.showAccInit = true;
              }
              if (this.$store.state.evaluatorReview.evalTest.vigilance_documentary_evaluation && !this.$store.state.evaluatorReview.evalTest.situ_checked) {
                this.showQuestionNoConf = true;
              }
          }
        
        }
        this.inputs = tmp;
      }
    },
    capitalizeFirstLetters(str){
      return str.toLowerCase().replace(/^\w|\s\w/g, function (letter) {
          return letter.toUpperCase();
      })
    },
  },
};
</script>
